import React, { useContext } from 'react';
import { Text } from '@usealloy/component-library';
import { RuleEditorContext } from '../../NodeEditorDrawer/context';
import { StyledClauseWrapper } from '../../NodeEditorDrawer/ThresholdsTab/styles';
import { StyledPre } from '../../../styles';
import isEmpty from 'lodash/isEmpty';
import { ContainerType } from '../../NodeEditorDrawer/ThresholdsTab/types';

const RuleClause = () => {
  const {
    showElseClause,
    isPreviewAction,
    sourceAction,
    containerType,
  } = useContext(RuleEditorContext);

  const isEmptyPreview = isPreviewAction && isEmpty(sourceAction.rules);

  return (
    <StyledPre style={{ alignSelf: containerType === ContainerType.DRAWER ? 'auto' : 'baseline' }}>
      {(showElseClause && (
        <StyledClauseWrapper>
          Else{' '}
        </StyledClauseWrapper>
      )
      )}
      <StyledClauseWrapper isEmptyPreview={isEmptyPreview}>
        If
        {isEmptyPreview && (
          <Text style={{ display: 'inline-flex', color: 'rgba(0, 0, 0, 0.5)' }}>
            {' (link threshold by clicking a node in the map)'}
          </Text>
        )}
      </StyledClauseWrapper>
    </StyledPre>
  );
};

export default RuleClause;
